<template>
  <div class="headway">
    <span>
      <i :class="['ra-icon--bell', { active: widgetActive }]" />
    </span>
  </div>
</template>

<script>
const HEADWAY_WIDGET_URL = "https://cdn.headwayapp.co/widget.js";
export default {
  name: "HeadwayWidget",
  data() {
    return {
      widgetActive: false,
      id: Math.random().toString(16),
      widget: undefined,
      config: {
        selector: ".headway",
        account: "J3ZBP7",
        callbacks: {
          onWidgetReady: widget => {
            this.widget = widget;
          },
          onShowWidget: () =>
            this.$parent.$emit("close:header-items", [this.id])
        }
      }
    };
  },
  methods: {
    hide() {
      if (this.widget) this.widget.hide();
      this.widgetActive = false;
    }
  },
  mounted() {
    let headwayScript = document.createElement("script");
    headwayScript.async = true;
    headwayScript.setAttribute("src", HEADWAY_WIDGET_URL);
    document.head.appendChild(headwayScript);
    const waitForHeadway = () => {
      if (window["Headway"]) {
        window.Headway.init(this.config);
      } else {
        setTimeout(() => waitForHeadway(), 100);
      }
    };
    waitForHeadway();
    this.$parent.$on("close:header-items", ([id]) => {
      if (this.id !== id) this.hide();
    });
  }
};
</script>

<style lang="scss">
.headway {
  margin-right: 15px;
  position: relative;
  cursor: pointer;

  span {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 1.375rem;
    }
  }
}

#HW_badge_cont {
  position: absolute !important;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  top: 30%;
  transform: translateY(-50%);
  display: flex !important;
  justify-content: flex-end;
}

#HW_badge {
  left: unset !important;
  position: relative !important;
  top: -5px !important;
  right: 15px !important;
}
</style>
